import React from 'react'

import { PureAccount } from './PureAccount'

interface IAccountProps {
  bankName?: string
  bankAccountNumber: string
  isBankNameWithLineBreak?: boolean
}

export const Account = (props: IAccountProps) => {
  const { isBankNameWithLineBreak = false } = props
  const BankName = () => {
    if (!props.bankName) {
      return <></>
    }
    if (isBankNameWithLineBreak) {
      return (
        <>
          {props.bankName}
          <br />
        </>
      )
    }

    return <PureAccount className="def-lst__acc--bank">{props.bankName}</PureAccount>
  }

  return (
    <>
      <BankName />
      <PureAccount>{props.bankAccountNumber}</PureAccount>
    </>
  )
}
